import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "react-bootstrap";

export function DefaultLoadingIndicator() {
  return (
    <Container fluid="xs" className="pt-1 ps-2">
      <Row>
        <Col>
          <div className="fa-2x">
            <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export const withDefaultLoadingIndicator = function (Component) {
  return function ({ isLoading, ...others }) {
    if (isLoading === true) {
      return DefaultLoadingIndicator();
    } else {
      return <Component {...others} />;
    }
  };
};

export const withLoadingIndicator = function (
  functionCondition,
  LoadingIndicator
) {
  return function (Component) {
    return function (props) {
      return functionCondition(props) ? (
        <LoadingIndicator {...props} />
      ) : (
        <Component {...props} />
      );
    };
  };
};

export const withLoadingIndicator2 = function (
  condition,
  LoadingIndicator,
  Component
) {
  return function (props) {
    if (condition) {
      return <LoadingIndicator {...props} />;
    } else {
      return <Component {...props} />;
    }
  };
};

export const withLoadingIndicator3 = function (LoadingIndicator, Component) {
  return function ({ isLoading, ...others }) {
    if (isLoading) {
      return <LoadingIndicator {...others} />;
    } else {
      return <Component {...others} />;
    }
  };
};
